var map = {
	"./bg-slider-page.jpg": 52,
	"./bring.svg": 53,
	"./chatbox.png": 54,
	"./duration.svg": 55,
	"./ecofriendly.svg": 56,
	"./excluded.svg": 57,
	"./flags/be.svg": 58,
	"./flags/cn.svg": 59,
	"./flags/de.svg": 60,
	"./flags/es.svg": 61,
	"./flags/fr.svg": 62,
	"./flags/gb.svg": 63,
	"./flags/it.svg": 64,
	"./flags/jp.svg": 65,
	"./flags/us.svg": 66,
	"./grapes.svg": 67,
	"./icons/calendar.svg": 68,
	"./icons/chevron.svg": 69,
	"./icons/close.svg": 70,
	"./icons/error.svg": 71,
	"./icons/facebook.svg": 72,
	"./icons/information.svg": 73,
	"./icons/instagram.svg": 74,
	"./icons/linkedin.svg": 75,
	"./icons/mail.svg": 76,
	"./icons/marker.svg": 77,
	"./icons/people.svg": 78,
	"./icons/phone2.svg": 79,
	"./icons/pinterest.svg": 80,
	"./icons/point.svg": 81,
	"./icons/slider-arrow.svg": 82,
	"./icons/star.svg": 83,
	"./icons/success.svg": 84,
	"./icons/time.svg": 85,
	"./icons/triangle.svg": 86,
	"./icons/twitter.svg": 87,
	"./icons/weibo.svg": 88,
	"./icons/youtube.svg": 89,
	"./included.svg": 90,
	"./languages.svg": 91,
	"./leaf.svg": 92,
	"./logo-communaute-gris.png": 93,
	"./logo.png": 94,
	"./meeting.svg": 95,
	"./phone.svg": 96,
	"./plant.svg": 97,
	"./price.svg": 98,
	"./secured-paiement.svg": 99,
	"./transportation.svg": 100,
	"./tripadvisor.png": 101,
	"./tripadvisor.svg": 102,
	"./tripadvisor_bg.png": 103,
	"./underline.svg": 104,
	"./underline_green.svg": 105,
	"./underline_green_2.svg": 106,
	"./validate.svg": 107
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51;